$(document).ready(function(){
 var active_prod_array = [];
 $('body').on('click', '.qauntity-wraper .incremant-spinner .quan', function(e){
 e.preventDefault;
 var total = parseInt($('.bundle_wrp').attr("total"));
 var limit = parseInt($('.bundle_wrp').attr("data-limit"));
 var product_prop = $(this).parents('.grid__item').find('.bundle_title').attr('product_prop');
 var qty = parseInt($(this).find('.item-qty:input').val());
 var input = $(this).parent().find('input');
 var ip = parseInt(input.val()); 

 var product_id = $(this).parents('.grid__item').attr('data-product-id');  
 if($(this).hasClass('incr')) {
     ip = ip + 1;
     total = total + 1;
    if(total == limit ){
      $('.bundle_main_bottom_btn').find(".error-bundle").css('display', 'none');
      $('.bundle_main_bottom_btn').find(".cart").removeAttr('disabled', 'disabled');
      $('.grid__item .button-wrp').addClass('is-disabled');
     
   }else{
    
     $('.bundle_main_bottom_btn').find(".error-bundle").css('display', 'block');
     $('.bundle_main_bottom_btn').find(".cart").attr('disabled', 'disabled');
     $('.grid__item .button-wrp').removeClass('is-disabled');   
   }
   if(total > 0){
      $('.bottom_item_main').show();
   }else{
      $('.bottom_item_main').hide();
   }
   
     $.getJSON('/products/'+$(this).parents('.grid__item').data('product-handle'),function(data){
      $('.bottom_item').each(function() {
        if($(this).hasClass('active')){
        }else{
          $(this).html('<div class="bottom_item_img product_'+ data.product.id+'"><img src="' + data.product.image.src + '" /></div><div class="bottom_item_text"><p class="b_text product_'+ data.product.id+'">'+data.product.title+'</p></div>')
          $(this).addClass('active');
          return false;
        }
      });
    });

   } else {
  if(ip == 1) {
   $('.bundle_button').css('display', 'none');
   $('.bottom_right_title').find('.budale_text').css('display', 'block');
   $(this).parents('.qauntity-wraper').css('display', 'none');
   $(this).parents('.grid__item').find('.grid-product__title').removeClass('bundle_add'); 
   $('.bundle_main_bottom_btn').find(".error-bundle").css('display', 'none');
 }
     ip = ip - 1;
     total = total - 1;
     if(total == limit ){
      $('.bundle_main_bottom_btn').find(".error-bundle").css('display', 'none');
      $('.bundle_main_bottom_btn').find(".cart").removeAttr('disabled', 'disabled');
      $('.grid__item .button-wrp').addClass('is-disabled');
   }else{
     $('.bundle_main_bottom_btn').find(".error-bundle").css('display', 'block');
     $('.bundle_main_bottom_btn').find(".cart").attr('disabled', 'disabled');
     $('.grid__item .button-wrp').removeClass('is-disabled');   
   }
    if(total > 0){
      $('.bottom_item_main').show();
   }else{
      $('.bottom_item_main').hide();
   }
     $.getJSON('/products/'+$(this).parents('.grid__item').data('product-handle'),function(data){
      $('.bottom_item').each(function() {
        if($(this).hasClass('active')){
          $('.bottom_item_img.product_'+ data.product.id+'').last().parents('.bottom_item').remove();
          $('.bottom_item_main_wp').append('<div class="bottom_item" data-id=""><div class="bottom_item_img"></div><div class="bottom_item_text"></div></div>');
           $(this).parents('.grid__item').find('.bundle_title').removeClass('bundle_add');
          return false;
        }
      });
    });
   }
 if(ip != 0){
     input.val( ip);
   }

$('.item-qty').attr("item-qty", ip);
var prod_title = $(this).parents('.grid__item').find('.bundle_title').attr('product_title');
$(this).parents('.grid__item').find('.bundle_title').attr('product_prop', ip + 'x '+ prod_title );

 $('.bundle_wrp').attr("total", total);
  $('.bottom_right_title').find('.total').html('('+total+')');
 if(total == limit ){
    $('.bundle_main_bottom_btn').find(".error-bundle").css('display', 'none');
    $('.bundle_main_bottom_btn').find(".cart").removeAttr('disabled', 'disabled');
 }else{
 $('.bundle_main_bottom_btn').find(".error-bundle").css('display', 'block');
 $('.bundle_main_bottom_btn').find(".cart").attr('disabled', 'disabled');
 }
});

$(this).parents('.grid__item').find('.bundle_title').removeClass('bundle_add');

$(".add").click(function(){

 var id = $(this).parents('.grid__item').attr('data-product-id');
 $('.bottom_item_main').show();
 qty_count = $('.bottom_item_img.product_'+id+'').length;
 $(this).parents('.grid__item').find('.item-qty').val(qty_count + 1);
 $('.bundle_button').css('display', 'block');
 $('.bottom_right_title').find('.budale_text').css('display', 'none');
 $(this).siblings(".qauntity-wraper").css('display', 'block');
 $(this).parents('.grid__item').find('.bundle_title').removeClass('bundle_add');
 $(this).parents('.grid__item').find('.bundle_title').addClass('bundle_add');
 var product_prop = $(this).parents('.grid__item').find('.bundle_title').attr('product_prop');
 var total = parseInt($('.bundle_wrp').attr("total"));
  var limit = parseInt($('.bundle_wrp').attr("data-limit"));
 total = total + 1;
 $('.bundle_wrp').attr("total", total);
 $('.bottom_right_title').find('.total').html('('+total+')');
  if(total == limit ){
    $('.bundle_main_bottom_btn').find(".error-bundle").css('display', 'none');
    $('.bundle_main_bottom_btn').find(".cart").removeAttr('disabled', 'disabled');
    $('.grid__item .button-wrp').addClass('is-disabled');
 }else{
   
   $('.bundle_main_bottom_btn').find(".error-bundle").css('display', 'block');
   $('.bundle_main_bottom_btn').find(".cart").attr('disabled', 'disabled');
   $('.grid__item .button-wrp').removeClass('is-disabled');   
 }

   if($('.bundle_title').hasClass('bundle_add')){
   var prod_title = $(this).parents('.grid__item').find('.bundle_title').attr('product_title');
   var qty = $(this).parents('.grid__item').find('.bundle_title').attr('item-qty');
     
    $(this).parents('.grid__item').find('.bundle_title').attr('product_prop', qty_count+1 + 'x '+ prod_title );
 }
 
  $.getJSON('/products/'+$(this).parents('.grid__item').data('product-handle'),function(data){
    $('.bottom_item').each(function() {
      if($(this).hasClass('active')){
      }else{
        $(this).html('<div class="bottom_item_img product_'+ data.product.id+'"><img src="' + data.product.image.src + '" /></div><div class="bottom_item_text"><p class="b_text product_'+ data.product.id+'">'+data.product.title+'</p></div>')
        $(this).addClass('active');
        return false;
      }
    });
    });

});
$('body').on('change','.bundle_main_bottom_btn .variant-input-wrap input',function(){
  var price = $(this).attr('data-price');
  var limit = parseInt($(this).attr('data-piece'));
  var added = parseInt($('.bundle_wrp').attr('total'));

  $('.bundle_price').text(price);
  $('.bundle_wrp').attr('data-limit',limit);
  $('.bundle_wrp').attr('total',0);
  $('.bundle_main_bottom_btn .error-bundle').text('Your box must contain '+limit+' products.');
  $('.bundle_main_bottom_btn').find(".cart").attr('disabled', 'disabled');
  $('.bottom_item_main_wp').empty();
  $('.bundle_wrp .grid__item').each(function(){
    $(this).find('.incremant-spinner .quantity-increment').val(1);
    $(this).find('.qauntity-wraper').hide();
    $(this).find('.button-wrp').removeClass('is-disabled');
  });
  for(var i = 0; i < limit; i++) {
    $('.bottom_item_main_wp').append('<div class="bottom_item" data-id=""><div class="bottom_item_img"></div><div class="bottom_item_text"></div></div>');
  } 
});
                              
  function addToCartSuccess(){
    //window.location.href = "/cart";
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }
  function addbundle(variant_array,redirect,btn,text){
    $.ajax({
    type: 'POST',
      url: '/cart/add.js',
      data: variant_array,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
      
      },
      success: function(){
          if(redirect){
            setTimeout(function(){
              // $('[name="attributes[Delivery Date]"]').val(csDateFormatter(result_data.generalSettingData.gen_date_format,new Date( snextDayAndTime(3, 19, 0).toString())));
              // var ctry = localStorage.getItem('CountryShop');
              // if(ctry != '' && ctry != 'undefined' && ctry != null){
              //   var conty = ctry;
              // }else{
              //   var conty = 'US';
              // }
              // $('#CartDrawerForm').attr('action','/cart?checkout[shipping_address][country]='+conty);
              // $('#csShippingCountry').val('conty');
              // $('#CartDrawerForm').submit();
              // document.location.href = '/cart/checkout?checkout[shipping_address][country]=US'; 
              //window.location.href = '/cart';
              document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            },1000);
          }else{
            // $('[name="attributes[Delivery Date]"]').val('');
            addToCartSuccess();
            btn.text(text);
            btn.removeAttr('disabled');  
          }
        
      }
    });
  }
  $('body').on('click','.cart',function(e){
    e.preventDefault();
  
    var btn = $(this);
    var continue_add = bundle_setcheck(btn);
    if(continue_add == false){
      return false;  
    }
    
    var text = $(this).text();
    var product_prop = {};
    
    $('.bundle_add').each(function( index ) {
      var property_data = $(this).attr('product_prop');
      product_prop[parseInt(index+1)] = property_data;
    });
    
    if($(this).hasClass('its_bundle_item')){
      var box_type= $(this).parents('form').find('[name="box-amount"]:checked').val();
      var redirect = true;
      product_prop['Box-Amount'] = box_type;
      var id = parseInt($(this).parents('form').find('[name="box-amount"]:checked').attr('data-id'));
      // var d = new Date('2023/06/09');
      // d.setDate(d.getDate() + (((3 + 7 - d.getDay()) % 7) || 7));
      // var date = d.getDate()+'/'+(d.getMonth()+1)+'/'+d.getFullYear();
      // var variant_array = {items: [{'quantity': 1,'id': id,'properties': product_prop}],attributes:{'Delivery Date':date}}};
      // if($('input[name="attributes[Delivery Date]"]').length > 0){
      //   $('input[name="attributes[Delivery Date]"]').val(date);
      // }
    }else{
      var redirect = false;
      var id = $('#variant').val();
    }
    var variant_array = {items: [{'quantity': 1,'id': id,'properties': product_prop}]};
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    // console.log(product_prop);console.log('!@!@!@!@',continue_add);
    
    if(continue_add == 'remove'){
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
          addbundle(variant_array,redirect,btn,text);
        },
        error: function(XMLHttpRequest, textStatus) {
          /* error code */
        }
      });
    }else{
      addbundle(variant_array,redirect,btn,text);
    }    
  }); 
});